<template>
  <v-card v-if="options">
    <v-card-title>
      {{ $t("deadlines.title") }}
    </v-card-title>

    <v-card-text class="pa-0">
      <v-timeline dense>
        <v-timeline-item small color="green">
          <span class="mr-4">{{ startEdit }}</span>
          <span class="">{{ $t("deadlines.applicationStart.label") }}</span>
        </v-timeline-item>

        <v-timeline-item small color="yellow">
          <span class="mr-4">{{ yellowDeadline }}</span>
          <span class="">{{ $t("deadlines.applicationYellow.label") }}</span>
        </v-timeline-item>

        <v-timeline-item small color="orange">
          <span class="mr-4">{{ orangeDeadline }}</span>
          <span class="">{{ $t("deadlines.applicationOrange.label") }}</span>
        </v-timeline-item>

        <v-timeline-item small color="red">
          <span class="mr-4">{{ redDeadline }}</span>
          <span class="">{{ $t("deadlines.applicationRed.label") }}</span>
        </v-timeline-item>

        <v-timeline-item small color="grey">
          <span class="mr-4">{{ $t("deadlines.call.date") }}</span>
          <span class="font-italic">{{ $t("deadlines.call.label") }}</span>
        </v-timeline-item>

        <v-timeline-item small color="black">
          <span class="mr-4">{{ auditPeriodClosedAt }}</span>
          <span class="">{{ $t("deadlines.end.label") }}</span>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import OptionsQuery from "@/gql/queries/auditor/OptionsQuery.gql";

export default {
  data() {
    return {
      options: null,
    };
  },

  apollo: {
    options: {
      query: OptionsQuery,
      fetchPolicy: "cache-and-network",
    },
  },

  computed: {
    yellowDeadline() {
      const date = new Date(this.options?.find((o) => o.key === "yellowDeadline")?.value);
      return date ? date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) : "";
    },

    orangeDeadline() {
      const date = new Date(this.options?.find((o) => o.key === "orangeDeadline")?.value);
      return date ? date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) : "";
    },

    redDeadline() {
      const date = new Date(this.options?.find((o) => o.key === "redDeadline")?.value);
      return date ? date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) : "";
    },

    startEdit() {
      const date = new Date(this.options?.find((o) => o.key === "startEdit")?.value);
      return date ? date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) : "";
    },

    auditPeriodClosedAt() {
      const date = new Date(this.options?.find((o) => o.key === "auditPeriodClosedAt")?.value);
      return date ? date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) : "";
    },
  },
};
</script>
